const OBJECT_BLOCK_VARIANT = Object.freeze({
    PREVIEW: 'preview',
    SIMPLE_PREVIEW: 'simple-preview',
    OVERVIEW: 'overview',
    LINKED: 'linked',
    SELECTION: 'selection',
});
export { OBJECT_BLOCK_VARIANT };
